import { createContext } from "react";
import { AdoraInternalUser } from "@adora/shared/utils/auth";

export interface UserContextType {
  user: AdoraInternalUser;
  setUser: React.Dispatch<React.SetStateAction<AdoraInternalUser>>;
}

const UserContext = createContext<UserContextType | null>(null);
export default UserContext;
